import React from "react"
import "../styles/Media.css"

export default function MediaPage() {

    return (
        <div className="mediaContainer">
            <div className="warningContent">
                Content Coming Soon
            </div>
        </div>
    )
}